export const ACTIVATE_PROMPT_MESSAGE = "ACTIVATE_PROMPT_MESSAGE";
export const DEACTIVATE_PROMPT_MESSAGE = "DEACTIVATE_PROMPT_MESSAGE";
